import React, { useEffect, useState } from 'react'
import SearchBar from './SearchBar'
import general from '../../general'
import Dialog from '../../lib/Dialog'
import { NavLink } from '../../lib/Navigation'
import useActiveState from '../../lib/useActiveState'
import {useLockFn} from "ahooks";

export default function Session(props) {

  const [data, setData] = useState([])
  const [user,setUser] = useActiveState('user')
  const [config] = useActiveState('config')
  const [isCheckAuth, setIsCheckAuth] = useState(false); //实名认证弹框状态
  const [authData, setAuthData] = useState({}); //实名认证参数值

  const getHotGameCluster = () => {
    general.axios.post('/base/yunxin/getHotGameCluster', { source: 'myself' })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setData(data.hot_game_cluster)
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    getHotGameCluster()
  }, [])

  const join = (item) => {
    if (user.isCheckAuth && !user.isRealNameAuth){
      setIsCheckAuth(true)
      setTimeout(() => {
        const div = document.getElementsByClassName("pay-check-auth")[0]
        const target = document.getElementsByClassName("adm-tabs")[0]
        target.insertAdjacentElement('afterend', div);
      }, 10);
      return
    }
    general.axios.post('/base/yunxin/joinTeams', { topic_id: item.topic_id })
      .then(res => {
        const { data, status } = res.data
        if (status.succeed) {
          const { tid } = data.info
          if (localStorage.getItem('yx_login')) {
            general.history.push(`/chat?tid=${tid}`)
          } else {
            PubSub.publish('loginSubscribe', true)
            setTimeout(() => {
              general.history.push(`/chat?tid=${tid}`)
            }, 2000)
          }
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  const certifiy = useLockFn(()=>{
    if(!authData.real_name) {
      Dialog.info('请输入姓名');
      return;
    }
    if(!authData.identity_card){
      Dialog.info('请输入身份证号');
      return;
    }
    Dialog.loading();
    general.axios.post('/user/user/editMemberInfo', {real_name:authData.real_name, identity_card:authData.identity_card})
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status, data} = res.data;
        
        if (!status.succeed) {
          Dialog.info(status.error_desc);
        } else {
          Dialog.info("认证成功");
          setIsCheckAuth(false);
          // setUser({...user, isRealNameAuth: true});
          setUser({...user, ...{real_name: authData.real_name, identity_card: authData.identity_card, isRealNameAuth: true, isAdult: data.isAdult}});
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
    })

  return (
    <div className='session-index'>
      <SearchBar></SearchBar>
      <NavLink className="empty">{user.isLogin ? '您还未加入任何群聊' : '登录后查看加入的群聊 >'}</NavLink>
      <div className="header">热门群聊</div>
      <div className="chats">
        {data.map((item, index) => {
          return (
            <div className='item' key={index}>
              <div className='imgs'>
                <img className='icon' src={item.icon} alt="" />
                <img className='tip' src={'resources/250410/hot.png'} alt="" />
              </div>
              <div className="name">{item.tname}</div>
              <NavLink onClick={() => join(item)} className="join">加群</NavLink>
            </div>
          )
        })}
      </div>
      {isCheckAuth?
        <div className="pay-check-auth">
          <div className="auth-index">
            <div className="close" onClick={() => {
              const div = document.getElementsByClassName("pay-check-auth")[0]
              const target = document.getElementsByClassName("chats")[0]
              target.insertAdjacentElement('afterend', div);
              setTimeout(() => {
                setIsCheckAuth(false)
              },10)
            }}>
              <img src="/resources/user/close.png" />
            </div>
            <div className="title">
              <div className="title-img">
                <img src="/resources/user/auth-title.png" />
              </div>
              <div>
                <h3>实名认证</h3>
                <p>
                {config.authTopTips}
                  {/* 根据国家新闻出版署最新规定，游戏用户需要进行实名认证，否则我们无法为您提供游戏及支付服务！ */}
                </p>
              </div>
            </div>

            <div className="auth-user-realname">
              <div className="auth-user-input">
                <div className="name">真实姓名</div>
                <input name="nick_name" type="text" placeholder="请输入姓名" autoComplete="off" value={authData.real_name} onChange={e => setAuthData({...authData, real_name: e.target.value})} />
              </div>
              <div className="auth-user-input">
                <div className="name">身份证号</div>
                <input name="number" type="text" placeholder="请输入身份证号" autoComplete="off" value={authData.identity_card} onChange={e => setAuthData({...authData, identity_card: e.target.value})} />
              </div>
              <span>
              {config.authBottomTips}
              {/* 您所提交的身份信息仅用于国家认证，我们将按照国家隐私条例严格保密信息，感谢您的支持！ */}
              </span>
              <div className="auth-user-btn" onClick={certifiy}>立即认证</div>
            </div>
          </div>
        </div> : null
      }
      
    </div>
  )
}
